/**
 * Tokens visuales del chat (v2): cercano a WhatsApp pero con identidad propia.
 * Función pura para poder testearla sin renderizar.
 */
export type BubbleSender = 'customer' | 'human' | 'bot'

export interface BubbleThemeInput {
  direction: 'in' | 'out'
  isBotAuthored?: boolean
  isScheduled?: boolean
  isCancelled?: boolean
  isFailed?: boolean
}

export interface BubbleTheme {
  sender: BubbleSender
  bubble: string
  meta: string
  quote: string
  quoteName: string
  quoteText: string
  text: string
}

export function resolveSender(input: Pick<BubbleThemeInput, 'direction' | 'isBotAuthored'>): BubbleSender {
  if (input.direction === 'in') return 'customer'
  return input.isBotAuthored ? 'bot' : 'human'
}

export function getBubbleTheme(input: BubbleThemeInput): BubbleTheme {
  const sender = resolveSender(input)
  const base = {
    sender,
    meta: 'text-slate-500',
    quote: 'border-slate-300 bg-black/5',
    quoteName: 'text-[#075f55]',
    quoteText: 'text-slate-700',
    text: 'text-slate-900',
  }

  if (sender === 'customer') {
    return { ...base, bubble: 'bg-white border border-slate-100 shadow-xs' }
  }

  if (input.isCancelled) {
    return { ...base, bubble: 'bg-slate-200 border border-slate-300 text-slate-600' }
  }
  if (input.isFailed) {
    return { ...base, bubble: 'bg-rose-50 border border-rose-300' }
  }
  if (input.isScheduled) {
    return { ...base, bubble: 'bg-blue-50 border border-dashed border-blue-300' }
  }
  if (sender === 'bot') {
    return { ...base, bubble: 'bg-violet-100 border border-violet-200 shadow-xs' }
  }
  return { ...base, bubble: 'bg-emerald-100 border border-emerald-200 shadow-xs' }
}
